.styledFilterDropdownMenuContent {
  max-height: min(
    var(--filter-max-height),
    var(--radix-dropdown-menu-content-available-height)
  );
}
